export const PORTAL_HOME_TITLE = '网易瑶台-元宇宙活动_元宇宙会议_元宇宙展会';
export const OEM_HOME_TITLE = '元宇宙活动_元宇宙会议_元宇宙展会';
export const PORTAL_HOME_TITLE_NO_YAOTAI = '元宇宙活动_元宇宙会议_元宇宙展会';

export const PERSONAL_CENTER_TITLE = '网易瑶台-个人中心';
export const PERSONAL_CENTER_TITLE_OEM = '个人中心';
